import { render, staticRenderFns } from "./TicketsView.vue?vue&type=template&id=b93a5054&scoped=true"
import script from "./TicketsView.vue?vue&type=script&lang=js"
export * from "./TicketsView.vue?vue&type=script&lang=js"
import style0 from "./TicketsView.vue?vue&type=style&index=0&id=b93a5054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b93a5054",
  null
  
)

export default component.exports